'use strict';

const veryFast = "150ms";
const fast = "200ms";
const moderate = "300ms";
const slow = "500ms";
const ultraSlow = "1400ms";

exports.fast = fast;
exports.moderate = moderate;
exports.slow = slow;
exports.ultraSlow = ultraSlow;
exports.veryFast = veryFast;
//# sourceMappingURL=duration.cjs.map
